
export default {
    name:"app-article-list-filter-item",
    props:['filter','name']

}
